/**
 * @file automatically generated from MApp.Spatial.Ogc.ComparisonType
 */

export enum ComparisonType {
    PropertyIsEqualTo = 0,
    PropertyIsNotEqualTo = 1,
    PropertyIsLessThan = 2,
    PropertyIsGreaterThan = 3,
    PropertyIsLessThanOrEqualTo = 4,
    PropertyIsGreaterThanOrEqualTo = 5,
    PropertyIsLike = 6,
    PropertyIsNull = 7,
    PropertyIsBetween = 8
}
